import { setStore, getStore, removeStore } from '../util/storage'

const USER_INFO = '__userinfo__'

export function saveUser(obj) {
    let userinfo = obj
    setStore(USER_INFO, obj)
    return userinfo
}

export function loadUser() {
    let u = getStore(USER_INFO)
    return u
}

export function removeUser() {
    return removeStore(USER_INFO)
}

const CART_INFO = '__cartinfo__'
export function saveCart(obj) {
    let cart = obj;
    setStore(CART_INFO, obj)
    return cart;
}
export function loadCart() {
    let c = getStore(CART_INFO)
    return c
}

const SAVE_BANK_STATUS = 'status'
export function saveCardStatus(obj) {
    let bankStatus = obj;
    setStore(SAVE_BANK_STATUS, obj)
    return bankStatus;
}
export function loadBankCard() {
    let bank = getStore(SAVE_BANK_STATUS)
    return bank
}

export function removeBankCard() {
    return removeStore(SAVE_BANK_STATUS)
}

const CODE_INFO = 'pcode'

export function savePcodeNum(obj) {
    let code = obj;
    setStore(CODE_INFO, obj)
    return code;
}
export function loadPcode() {
    let p = getStore(CODE_INFO)
    return p
}

const ACTIVITY_PIC = 'pic'

export function savePic(obj) {
    let pic = obj;
    setStore(ACTIVITY_PIC, obj)
    return pic;
}
export function loadPic() {
    let ac = getStore(ACTIVITY_PIC)
    return ac
}

const AGENT_SHOW = 'agent'
export function saveAgentStatus(obj) {
    let agentStatus = obj;
    setStore(AGENT_SHOW, obj)
    return agentStatus;
}
export function loadAgentStatus() {
    let agent = getStore(AGENT_SHOW)
    return agent
}


const ORDER_LIST = '__order_list__';
export function loadOrder() {
    let orderList = getStore(ORDER_LIST)
    if (orderList == null) {
        return [];
    }
    return orderList;
}
export function removeOrder(orderId) {
    let orderList = getStore(ORDER_LIST)
    if (orderList == null) {
        return
    }
    let index = orderList.indexOf(orderId);
    orderList.splice(index, 1);
    setStore(ORDER_LIST, orderList)
    return orderId;
}
export function addOrder(orderId) {
    let orderList = getStore(ORDER_LIST)
    if (orderList == null) {
        orderList = [];
    }
    orderList.push(orderId);
    setStore(ORDER_LIST, orderList)
    return orderId;
}